module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Corrigan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("John Corrigan")]), _vm._v(" is the Lucius Moody Bristol Distinguished Professor of Religion and professor of history at Florida State University. He is the author of numerous books, including "), _c('I', [_vm._v("Religious Intolerance, America, and the World: A History of Forgetting and Remembering")]), _vm._v(", also published by the University of Chicago Press.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yVOYOu/tc-custom/9780226827643.jpg?1722572673417",
      "alt": "This image is the cover for the book Feeling of Forgetting"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Feeling of Forgetting\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A provocative examination of how religious practices of forgetting drive white Christian nationalism.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The dual traumas of colonialism and slavery are still felt by Native Americans and African Americans as victims of ongoing violence toward people of color today. In "), _c('i', [_vm._v("The Feeling of Forgetting")]), _vm._v(", John Corrigan calls attention to the trauma experienced by white Americans as perpetrators of this violence. By tracing memory’s role in American Christianity, Corrigan shows how contemporary white Christian nationalism is motivated by a widespread effort to forget the role race plays in American society. White trauma, Corrigan argues, courses through American culture like an underground river that sometimes bursts forth into brutality, terrorism, and insurrection. Tracing the river to its source is a necessary first step toward healing."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0